/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-progress-background-color: Specifies the component's background color.
* @prop --calcite-progress-fill-color: Specifies the component's fill color.
* @prop --calcite-progress-text-color: Specifies the component's text color.
*/
/* helper to properly scale internal durations */
:host {
  position: relative;
  display: block;
  inline-size: 100%;
}

.track,
.bar {
  position: absolute;
  inset-block-start: 0px;
  block-size: 2px;
}

.track {
  z-index: var(--calcite-z-index);
  inline-size: 100%;
  overflow: hidden;
  background-color: var(--calcite-progress-background-color, var(--calcite-color-border-3));
}

.bar {
  z-index: var(--calcite-z-index);
  background-color: var(--calcite-progress-fill-color, var(--calcite-color-brand));
}

@media (forced-colors: active) {
  .track {
    background-color: highlightText;
  }
  .bar {
    background-color: linkText;
  }
}
.indeterminate {
  inline-size: 20%;
  animation: looping-progress-bar-ani calc(var(--calcite-internal-animation-timing-medium) / var(--calcite-internal-duration-factor) * 11 / var(--calcite-internal-duration-factor)) linear infinite;
}
.indeterminate.calcite--rtl {
  animation-name: looping-progress-bar-ani-rtl;
}

.reversed {
  animation-direction: reverse;
}

.text {
  padding-inline: 0px;
  padding-block: 1rem 0px;
  text-align: center;
  font-size: var(--calcite-font-size--2);
  line-height: 1rem;
  font-weight: var(--calcite-font-weight-medium);
  color: var(--calcite-progress-text-color, var(--calcite-color-text-2));
}

@keyframes looping-progress-bar-ani {
  0% {
    transform: translate3d(-100%, 0, 0);
  }
  50% {
    inline-size: 40%;
  }
  100% {
    transform: translate3d(600%, 0, 0);
  }
}
@keyframes looping-progress-bar-ani-rtl {
  0% {
    transform: translate3d(100%, 0, 0);
  }
  50% {
    inline-size: 40%;
  }
  100% {
    transform: translate3d(-600%, 0, 0);
  }
}
:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}